// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"OK-z","smallCardRow":"PK-z","largeCardRow":"QK-z","productSearchRow":"RK-z","curatedRow":"SK-z"};